import { useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { BASE_URL } from "../../config/constants";

export default function SecureImage({imageUrl, className="", style={}}){

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(()=>{
        setIsLoaded(false)
    },[imageUrl])

    return(
        <>
            <img src={ imageUrl} className={className} style={!isLoaded ? {height:0,width:0} : style} onLoad={()=>{setIsLoaded(true)}} />
            {!isLoaded ? 
               <div style={{width:"35px", height:"35px"}}><Spinner/></div> : null}
        </>
    )
}